import axiosInstance from '../utils/axios';

const expenseService = {
  createExpense: async (payload) => {
    const res = await axiosInstance.post('/expenses/entries', payload);
    return res.data;
  },
  listExpenses: async (params = { page: 0, size: 10 }) => {
    const res = await axiosInstance.get('/expenses/entries', { params });
    return res.data;
  }
};

export default expenseService;
